import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Booking/BookingForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Booking/ContactInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookNowPageClient"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/HeroBanner/BookNowPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Testimonial.tsx");
